import { createAction } from '@reduxjs/toolkit';

export const entityJurisdictionsDetailResetAction = createAction('entityJurisdictionsDetail/reset');
